import { TRACK_IDS } from "../../../analytics/trackIds";
import React, { useEffect } from "react";
import BackSecondsIcon from "../../../assets/icons/svg/BackSecondsIcon";
import localizationStrings from "../../../statics/localization";
import moment from "moment";
import { seekBy } from "./playerInteraction";

const RewindBackButton = ({
  player,
  setIsLiveEdge,
  isLive,
  isTimeshiftEnable,
  isPltv,
  rewindBackTv,
  isFullscreen,
  program
}) => {
  let secsToBack = 10;

  const isNearBeginTime = () => {
    let now = new Date().getTime() / 1000;
    let currentTime = player?.currentTime();
    let liveCurrentTime = player?.getChild("LiveTracker").liveCurrentTime();
    let beginTime =
      moment(program?.begintime, "YYYY.MM.DD HH:mm").valueOf() / 1000;
    let progress = now - (liveCurrentTime - currentTime) - beginTime;
    return progress;
  };

  useEffect(() => {
    if (!isPltv || !player) return;
    let timer;
    const onPlay = () => {
      timer = setTimeout(() => seekBy(player, -secsToBack), 200);
      player.off("play", onPlay);
    };
    player.on("play", onPlay);
    return () => {
      clearTimeout(timer);
      player.off("play", onPlay);
    };
  }, [isPltv, player]);

  return (
    <button
      data-track-id={TRACK_IDS.PLAYER_REWIND_BACK}
      className="control-button"
      style={{
        cursor: isTimeshiftEnable ? "pointer" : "not-allowed"
      }}
      title={localizationStrings.playerOptions.secsToBack}
      onClick={() => {
        if (isLive) {
          if (isTimeshiftEnable) {
            if (isPltv) {
              seekBy(player, -secsToBack);
            } else {
              seekBy(player, -secsToBack);
              setIsLiveEdge("1");
              rewindBackTv(Math.random() * 1000);
            }
          }
        } else {
          seekBy(player, -secsToBack);
        }
      }}
    >
      <BackSecondsIcon />
    </button>
  );
};

export default RewindBackButton;
